import { FeedbackItem } from "../../types";

import { message } from "antd";
import { useUpdateMessage } from "../../Utils/useUpdateMessage";
import { isTrue } from "../../polyfills";

// socket回执

export function useOnFeedback() {
    const chat = useUpdateMessage();

    function onFeedback(data: FeedbackItem) {
        if (!isTrue(data.success)) {
            chat.updateMessage(data.sessionId, data.messageId, {
                error: data.errorMessage
            });
            message.warn(data.errorMessage);
        }
    }

    return onFeedback;
}
